<template>
  <section class="how-to-section">
    <h2 class="section-title">{{ title }}</h2>
    <p v-if="description" class="section-description">{{ description }}</p>
    <div class="steps-container">
      <div class="step" v-for="(step, index) in steps" :key="index">
        <h3>{{ step.title }}</h3>
        <div v-if="isNestedStructure(step.items)" class="nested-steps">
          <div v-for="(subStep, subIndex) in step.items" :key="subIndex" class="sub-step">
            <h4 v-if="subStep.title">{{ subStep.title }}</h4>
            <ul v-if="subStep.content">
              <li v-for="(item, itemIndex) in subStep.content" :key="itemIndex" v-html="item"></li>
            </ul>
            <ul v-else-if="Array.isArray(subStep)">
              <li v-for="(item, itemIndex) in subStep" :key="itemIndex" v-html="item"></li>
            </ul>
          </div>
        </div>
        <ul v-else>
          <li v-for="(item, itemIndex) in step.items" :key="itemIndex" v-html="item"></li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HowToSection',
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    steps: {
      type: Array,
      required: true,
      validator: function (value) {
        return value.every(step => 
          step.title && 
          Array.isArray(step.items) && 
          step.items.length > 0
        )
      }
    }
  },
  methods: {
    isNestedStructure(items) {
      // 检查是否是嵌套结构：items 中的元素是否有 title 和 content 属性
      return items && items.length > 0 && items[0] && typeof items[0] === 'object' && (items[0].title || items[0].content)
    }
  }
}
</script>

<style scoped>
/* How to Download Section - 无背景色 */
.how-to-section {
  background: transparent;
  color: #333;
  padding: 40px 20px;
  position: relative;
}

.how-to-section .section-title {
  color: #333;
  margin-bottom: 20px;
  text-align: center;
  font-size: 2.5rem;
  font-weight: 700;
  line-height: 1.2;
}

.section-description {
  color: #666;
  margin-bottom: 50px;
  text-align: center;
  font-size: 1.2rem;
  line-height: 1.6;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.steps-container {
  max-width: 1000px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
}

.step {
  background: linear-gradient(180deg, #B420FD 0%, #5B68F8 100%);
  padding: 30px;
  border-radius: 20px;
  box-shadow: 0 8px 25px rgba(0,0,0,0.1);
  border: 1px solid #e9ecef;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

.step::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.step:hover {
  box-shadow: 0 12px 35px rgba(0,0,0,0.15);
  transform: translateY(-5px);
  border-color: #667eea;
}

.step:hover::before {
  opacity: 1;
}

.step h3 {
  margin-bottom: 20px;
  color: #fff;
  font-weight: 600;
  position: relative;
  z-index: 1;
}

.step ul {
  list-style: none;
  padding: 0;
  position: relative;
  z-index: 1;
}

.step li {
  padding: 8px 0;
  color: #fff;
  font-size: 16px;
  position: relative;
  padding-left: 25px;
  list-style: none;
}

.step li::before {
  content: '✓';
  position: absolute;
  left: 0;
  color: #4ecdc4;
  font-weight: bold;
}

/* Nested Steps Styles */
.nested-steps {
  margin-top: 15px;
}

.sub-step {
  margin-bottom: 20px;
  padding: 15px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  border-left: 3px solid #4ecdc4;
}

.sub-step h4 {
  color: #fff;
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 10px;
  position: relative;
  z-index: 1;
}

.sub-step ul {
  margin: 0;
  padding-left: 0;
}

.sub-step li {
  padding: 5px 0;
  color: #fff;
  font-size: 15px;
  position: relative;
  padding-left: 20px;
  list-style: none;
}

.sub-step li::before {
  content: '•';
  position: absolute;
  left: 0;
  color: #4ecdc4;
  font-weight: bold;
  font-size: 18px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .how-to-section .section-title {
    font-size: 2rem;
  }
  
  .steps-container {
    grid-template-columns: 1fr;
    gap: 30px;
  }
}
</style>
